export default __webpack_public_path__ + "static/media/ava.6f09b693.svg";